import React, { useEffect, useState } from "react";
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Grid,
} from "@material-ui/core";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  listItem: {
    cursor: "pointer",
    // "&:hover": {
    //   cursor: "pointer",
    //   color: "#3755a4",
    // },
    "&.active": {
      cursor: "pointer",
      color: "#3755a4",
      // "& ~ .list-icon": {
      //   display: "block",
      // },
    },
    // "& ~ .list-icon": {
    //   display: "none",
    // },

    lightColor: {
      color: "#007BFF",
    },
  },
});
const ItemList = ({
  suggestion,
  searchQuery,
  onClick,
  item,
  selected,
  children,
}) => {
  const [isActive, setIsActive] = useState(false);
  const getStyledSuggestion = (suggestion) => {
    // if (suggestion.toLowerCase() === searchQuery.toLowerCase()) {
    //   return <b className="string-matched">{suggestion}</b>;
    // }
    const searchQueryLength = searchQuery.length;
    return (
      <>
        <b>{suggestion.substring(0, searchQueryLength)}</b>
        {suggestion.substring(searchQueryLength)}
      </>
    );
  };

  const handleClick = (suggestion) => {
    onClick(suggestion, item);
  };
  return (
    <>
      <ListItem
        // className={`${isActive ? "active-list" : ""} left-list-items`}
        className="left-list-items"
        key={suggestion["suggestion"]}
        onClick={(e) => {
          return handleClick(suggestion["suggestion"]);
        }}
      >
        {selected === item ? (
          <ListItemText
            primary={<b className="active">{suggestion["suggestion"]}</b>}
          />
        ) : (
          <ListItemText
            primary={getStyledSuggestion(suggestion["suggestion"])}
          />
        )}
        {selected === item && (
          <ListItemSecondaryAction>
            <NavigateNextOutlinedIcon />
          </ListItemSecondaryAction>
        )}
      </ListItem>
      <li className="show-on-mobile">{selected === item && children}</li>
    </>
  );
};

export default withStyles(styles)(ItemList);
